( function () {
    'use strict';
    jQuery.extend( true, e4.settings, {
        search: {
            debounceDelay: 250,
            result: {
                pages: {
                    show: ( function () {
                        return ( jQuery( 'html' ).data( 'search-pages' ) === 'True' );
                    }() )
                },
                products: {
                    show: ( function () {
                        return ( jQuery( 'html' ).data( 'search-products' ) === 'True' );
                    }() ),
                    showAllLink: '#',
                    max: {
                        xs: 3,
                        sm: 3,
                        md: 6,
                        lg: 6,
                        xl: 6
                    }
                }
            },
            videos: {
                url: 'system/data/videos'
            },
            faq: {
                url: 'system/data/faq'
            },
            therapyareas: {
                url: 'system/data/therapyareas'
            },
            premiumpages: {
                url: 'system/data/premiumpages'
            },
            supportmaterials: {
                url: 'system/data/supportMaterials'
            },
            elearning: {
                url: 'system/data/elearning'
            },
            events: {
                url: 'system/data/events'
            },
            news: {
                url: 'system/data/news'
            },
            salesContacts: {
                url: '/system/data/contacts'
            },
            typeahead: {
                url: '/system/data/typeahead'
            }
        },
        ecom: {
            product: {
                details: {
                    url: 'system/data/ProductRelatedDetails'
                }
            }
        },
        parallax: {
            speed: -0.35
        },
        maps: {
            zoom: {
                min: 12,
                max: 15,
                initial: 2
            },
            center: {
                initialLat: 0.00,
                initialLng: 0.00
            }
        }
    } );
}() );
